import React from 'react'
import { Card, CardContent, Typography, Box, Chip } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'
import { ISystemVersioningEvent } from '../graphql'
import dayjs from 'dayjs'

interface VersionInfoCardProps {
  versionEvent: ISystemVersioningEvent
}

export const VersionInfoCard: React.FC<VersionInfoCardProps> = ({ versionEvent }) => {
  return (
    <Card sx={{ backgroundColor: 'background.paper' }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
          <InfoIcon sx={{ color: 'primary.main', fontSize: 32 }} />

          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" gutterBottom>
              Current Version
            </Typography>

            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 1, flexWrap: 'wrap' }}>
              <Chip label={`v${versionEvent.versionNumber}`} color="primary" size="medium" />
              <Typography
                variant="caption"
                sx={{
                  fontFamily: 'monospace',
                  backgroundColor: 'action.hover',
                  px: 1,
                  py: 0.5,
                  borderRadius: 1,
                }}
              >
                {versionEvent.versionHash.substring(0, 8)}
              </Typography>
            </Box>

            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              {versionEvent.description}
            </Typography>

            <Typography variant="caption" color="text.secondary">
              Released: {dayjs(versionEvent.startDatetime).format('MMM D, YYYY h:mm A')}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}
